import { render, staticRenderFns } from "./MainMenuButton.vue?vue&type=template&id=0dfd3b0a&scoped=true"
import script from "./MainMenuButton.vue?vue&type=script&lang=js"
export * from "./MainMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfd3b0a",
  null
  
)

export default component.exports